import axios from 'axios';

const api = '/api/agent-performance';

export const getAgentPrehlad = agentId => {
  return axios.get(`${api}/prehlad/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getDruzstvoPrehlad = agentId => {
  return axios.get(`${api}/druzstvo/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getZivotne = agentId => {
  return axios.get(`${api}/zivotne/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getNezivotne = agentId => {
  return axios.get(`${api}/nezivotne/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getUvery = agentId => {
  return axios.get(`${api}/uvery/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getLegalCounseling = agentId => {
  return axios.get(`${api}/legal-counseling/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getAcountingServices = agentId => {
  return axios.get(`${api}/acounting-services/${agentId}?cacheBuster=${new Date().getTime()}`);
};

export const getPerzistencia = agentId => {
  return axios.get(`${api}/perzistencia/${agentId}?cacheBuster=${new Date().getTime()}`);
};
